import React, { useEffect, useState } from "react";
import Utils from "./../Utils";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Auth from "../Auth";
var dateFormat = require("dateformat");

const Completion = ({ userCache }) => {
  const [completion, setCompletion] = useState(null);
  const [user, setUser] = useState(null);
  const [notFound, setNotFound] = useState(false);

  let { id } = useParams();

  useEffect(() => {
    const fetchCompletion = async () => {
      try {
        const data = await Auth.fetchWithIdToken(`/api/admin/completion/${id}`, {});

        if (data.success && data.completion) {
          setCompletion(data.completion);
          userCache.fetchIds([data.completion.userId]).then(() => {
            setUser(userCache.getUser(data.completion.userId));
          });
        } else {
          setNotFound(true);
        }
      } catch (error) {
        console.error('Error fetching completion:', error);
        setNotFound(true);
      }
    };

    fetchCompletion();
  }, [id, userCache]);

  let completions;

  if (completion) {
    completions = completion.completions.map((c, i) => {
      return (
        <>
          <h4>#{i + 1}</h4>
          <p>{Utils.nl2br(c)}</p>
        </>
      );
    });
  }

  return (
    <div id="completion-get">
      <div className="inner">
        {notFound && <h2>Completion not found</h2>}

        {completion && !notFound && (
          <div className="expanded-row">
            <h1>Completion {completion.id}</h1>

            <small>
              Created on{" "}
              <Link to={`/admin/card-set/${completion.id}`}>{dateFormat(new Date(completion.createdAt), "mm/dd/yyyy hh:MM:ss")}</Link>
            </small>

            {user && (
              <small>
                By <Link to={`/admin/user/${user.email}`}>{user.email}</Link>
              </small>
            )}
            <h3>Prompt</h3>
            <p>{Utils.nl2br(completion.prompt)}</p>

            <h3>Completions</h3>
            {completions}
          </div>
        )}
      </div>
    </div>
  );
};

export default Completion;
